import { render, staticRenderFns } from "./Deposit.vue?vue&type=template&id=085154c0&scoped=true&"
import script from "./Deposit.vue?vue&type=script&lang=js&"
export * from "./Deposit.vue?vue&type=script&lang=js&"
import style0 from "./Deposit.vue?vue&type=style&index=0&id=085154c0&prod&lang=css&"
import style1 from "./Deposit.vue?vue&type=style&index=1&id=085154c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085154c0",
  null
  
)

export default component.exports